import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
//Actions
import { getClans } from '../../actions/clans';
//Components
import AppLog from './AppLog';
import GuardLog from './GuardLog';
import IntercomLog from './IntercomLog';
import PhonebotLog from './PhonebotLog';
import Passes from './Passes';
import SelectLog from './SelectLog';
import Tags from './Tags';

function Log({ getClans }) {
  const [clan, setClan] = useState(0);
  const [view, setView] = useState('app');
  useEffect(() => {
    getClans();
  });
  function select() {
    switch (view) {
      case 'app':
        return <AppLog clan={clan} />;
      case 'guard':
        return <GuardLog clan={clan} />;
      case 'intercom':
        return <IntercomLog clan={clan} />;
      case 'pass':
        return <Passes clan={clan} />;
      case 'phonebot':
        return <PhonebotLog clan={clan} />;
      case 'tag':
        return <Tags clan={clan} />;
      default:
        return <AppLog clan={clan} />;
    }
  }
  return (
    <Fragment>
      <SelectLog view={view} setView={setView} clan={clan} setClan={setClan} />
      {select()}
    </Fragment>
  );
}

const mapDispatchToProps = (dispatch) => ({
  getClans: () => dispatch(getClans()),
});

export default connect(null, mapDispatchToProps)(Log);
